import React, { useEffect, useMemo, useState } from 'react'
import Switch from 'react-switch';
import Select from 'react-select';
import { ConfirmationModal } from '../../../../customControl/ConfirmationModal';
import { AccoutDetailsModal, SupplierPolicyDataCollection, SupplierProps } from './SupplierUtils';
import { ApiNotRespondMessage, isValidBankAccountNumber, isValidEmail, isValidIFSCCode, isValidPAN, isValidTAN, onlyAlphabets, onlyNumeric } from '../../../commonClass/CommonValidation';
import { selectOption } from '../../../commonClass/CommonInterfaceTypes';
import { useDispatch } from 'react-redux';
import { loaderActions } from '../../../../_actions/loader.actions';
import { patchUsersData, postUsersData, verifytoken } from '../../../../services/ApiCallingUserServices';
import { ClearLocalStorage } from '../../../commonClass/Session';

const AccountDetails = (props: SupplierProps) => {
    const { dropdownData, SupplierId, disable, editdisable, cleardisable, type, retrieveData, UserId, SupplierName } = props;

    const dispatch = useDispatch();

    const [formValue, setFormValue] = useState(new AccoutDetailsModal());
    const [formError, setFormError] = useState<any>(null);
    const [PolicyValue, setPolicyValue] = useState(new SupplierPolicyDataCollection())
    const [SupplierPolicy, setSupplierPolicy] = useState<SupplierPolicyDataCollection[]>([])

    const [modalShow, setModalShow] = useState(false);
    const [activeId, setActiveId] = useState(false);
    const [addbuttontext, setAddButtonText] = useState(type === "Edit" ? "Update" : "Save");

    const [disabled, setDisabled] = useState(disable);
    const [editDisabled, setEditDisabled] = useState(editdisable);


    //#region retrieve data
    useEffect(() => {
        setFormValue((form) => ({
            ...form,
            SupplierId: SupplierId,
            UserId: UserId
        }));
        if (retrieveData) {
            setFormValue((form) => ({
                ...form,
                SupplierAccountId: retrieveData?.supplierAccountId ? retrieveData?.supplierAccountId : 0,
                AccountNumber: retrieveData?.accountNumber ? retrieveData?.accountNumber : "",
                AccountName: retrieveData?.accountName ? retrieveData?.accountName : "",
                BankName: retrieveData?.bankName ? retrieveData?.bankName : "",
                IFSCCode: retrieveData?.ifscCode ? retrieveData?.ifscCode : "",
                BranchName: retrieveData?.branchName ? retrieveData?.branchName : "",
                BranchCode: retrieveData?.branchCode ? retrieveData?.branchCode : "",
                PANNo: retrieveData?.panNo ? retrieveData?.panNo : "",
                MICRNumber: retrieveData?.micrNumber ? retrieveData?.micrNumber : "",
                TANNo: retrieveData?.tanNo ? retrieveData?.tanNo : "",
                MobileNo: retrieveData?.mobileNo ? retrieveData?.mobileNo : "",
                Email: retrieveData?.email ? retrieveData?.email : "",
                IsActive: retrieveData?.isActive ? retrieveData?.isActive : false,
                DataCollection: retrieveData?.dataCollection ? retrieveData?.dataCollection : [],
            }))
            setActiveId(retrieveData?.isActive ? retrieveData?.isActive : false);
            retrieveData?.dataCollection?.map((obj: any, index: number) => {
                obj.SeqNo = index + 1
                return obj;
            })
            setSupplierPolicy(retrieveData?.dataCollection ? retrieveData?.dataCollection : [])
        }
    }, [retrieveData, UserId, SupplierId])
    //#endregion


    const handleOnChange = (name: string, value: string) => {
        setEditDisabled(false);
        setFormError(null);
        setFormValue((form) => ({ ...form, [name]: value }));
    }

    const handleisActive = (e: any) => {
        if (addbuttontext === 'Save') {
            formValue.IsActive = e
            setActiveId(!activeId)
            setFormError(null);
        }
        else {
            setModalShow(true);
        }
    }
    const handleConfirmation = (e: any) => {
        //setYesNoConfirm(e)
        if (e === true) {
            formValue.IsActive = !activeId
            setActiveId(!activeId)
            setEditDisabled(false);
            setFormError(null);
        }
        setModalShow(false);
    }

    const handleSelectChange = (name: string, e: selectOption) => {
        setEditDisabled(false);
        setFormError(null);
        if (name === 'dTravelId') {
            setPolicyValue((policy) => ({
                ...policy, dTravelValue: e.label, dTravelId: e.value
            }))
        }
        else {
            setPolicyValue((policy) => ({
                ...policy, sPaymentValue: e.label, sPaymentId: e.value
            }))
        }
    }

    const validatePolicyData = () => {
        let status = true;
        let error: any = {};

        const isDupDTravelId = SupplierPolicy?.filter((fil) => fil.dTravelId === PolicyValue.dTravelId);

        if (PolicyValue.dTravelId <= 0) {
            error.DTravel = "Kindly select any of the D-Travel"
            status = false;
        }
        if (isDupDTravelId?.length > 0) {
            error.DTravel = "You can not select the same value of D-Travel"
            status = false;
        }
        if (PolicyValue.sPaymentId <= 0) {
            error.sPaymentValue = "Kindly select a value"
            status = false;
        }

        setFormError(error);
        return status;
    }

    const handleAddSupplierPolicy = () => {
        if (validatePolicyData()) {
            setSupplierPolicy((prev) => ([
                ...prev,
                {
                    sPaymentValue: PolicyValue.sPaymentValue,
                    sPaymentId: PolicyValue.sPaymentId,
                    dTravelValue: PolicyValue.dTravelValue,
                    dTravelId: PolicyValue.dTravelId,
                    SeqNo: SupplierPolicy?.length + 1
                }
            ]))
            setPolicyValue(new SupplierPolicyDataCollection())
        }
    }

    const handleRemoveSupplierPolicy = (e: any, id: number) => {
        e.preventDefault();
        setFormError(null);
        setEditDisabled(false);
        setSupplierPolicy(SupplierPolicy?.filter((fil: any) => fil.SeqNo !== id)?.map((obj, index) => ({ ...obj, SeqNo: index + 1 })))
    }


    const validateData = () => {
        let status = true;
        let error: any = {};

        if (formValue?.AccountNumber?.trim()?.length === 0) {
            error.AccountNumber = "Kindly enter the account number"
            status = false;
        }
        if (formValue?.AccountNumber && (formValue?.AccountNumber?.trim()?.length < 9 || !isValidBankAccountNumber(formValue?.AccountNumber))) {
            error.AccountNumber = "Kindly enter the correct account number"
            status = false;
        }
        if (formValue?.AccountName?.trim()?.length === 0) {
            error.AccountName = "Kindly Enter your Account Name"
            status = false;
        }
        if (formValue?.BankName?.trim()?.length === 0) {
            error.BankName = "Kindly Enter your Bank Name"
            status = false;
        }
        if (formValue?.IFSCCode?.trim()?.length === 0) {
            error.IFSCCode = "Kindly Enter IFSC code"
            status = false;
        }
        if (formValue?.IFSCCode && !isValidIFSCCode(formValue?.IFSCCode)) {
            error.IFSCCode = "Kindly enter the correct IFSC code"
            status = false;
        }
        if (formValue?.BranchName?.trim()?.length === 0) {
            error.BranchName = "Kindly Enter Branch Name"
            status = false;
        }
        if (formValue?.BranchCode?.trim()?.length === 0) {
            error.BranchCode = "Kindly Enter your Bank Code"
            status = false;
        }
        if (formValue?.PANNo && !isValidPAN(formValue?.PANNo)) {
            error.PANNumber = "Kindly enter the correct PAN number"
            status = false;
        }
        // if (formValue?.MICRNumber?.trim()?.length === 0) {
        //     error.MICRNumber = "Kindly enter the MICR number"
        //     status = false;
        // }
        if (formValue?.MICRNumber && formValue?.MICRNumber?.trim()?.length < 9) {
            error.MICRNumber = "Kindly enter the correct MICR number"
            status = false;
        }
        if (formValue?.TANNo && !isValidTAN(formValue?.TANNo)) {
            error.TANNumber = "Kindly enter the correct TAN Number"
            status = false;
        }
        // if (formValue?.MobileNo?.trim()?.length === 0) {
        //     error.MobileNumber = "Kindly enter the mobile number"
        //     status = false;
        // }
        if (formValue?.MobileNo && formValue?.MobileNo?.trim()?.length < 10) {
            error.MobileNumber = "Kindly enter the correct the mobile number"
            status = false;
        }
        if (formValue?.Email?.trim()?.length === 0) {
            error.AccountEmail = "Kindly Enter your Email"
            status = false;
        }
        if (formValue?.Email && !isValidEmail(formValue?.Email)) {
            error.AccountEmail = "Email id should in a format abc@xyz.com"
            status = false;
        }
        if (formValue?.DataCollection?.length <= 0) {
            error.SupplierPayment = "Please enter supplier payment value"
            status = false;
        }

        setFormError(error);
        return status;
    }

    const handleSaveUpdate = async () => {
        formValue.BranchCode = formValue?.IFSCCode?.slice(-6)
        formValue.DataCollection = SupplierPolicy
        if (validateData()) {
            dispatch(loaderActions.start());
            let statusoftoken = await verifytoken();
            if (statusoftoken) {
                const insertUpdateSupplierAccount = formValue?.SupplierAccountId > 0 ?
                    await patchUsersData('/midoffice/v1/updatesuppaccount', formValue)
                    :
                    await postUsersData('/midoffice/v1/insertsuppaccount', formValue)
                if (insertUpdateSupplierAccount?.status) {
                    dispatch({ type: 'ALERTINGMESSAGE', message: insertUpdateSupplierAccount?.message || ApiNotRespondMessage, path: "/supplier-list" });
                    dispatch(loaderActions.end());
                }
                else {
                    dispatch({ type: 'ALERTING', message: insertUpdateSupplierAccount?.message || ApiNotRespondMessage });
                    dispatch(loaderActions.end());
                }
            }
            else {
                dispatch(loaderActions.end());
                ClearLocalStorage();
                dispatch({ type: 'SESSIONOUT', message: 'Your Session Expired. Please Login Again!' });
            }

        }
    }


    const handleClear = () => {
        setEditDisabled(false);
        setFormError(null);
        setFormValue((form) => ({
            ...form,
            AccountNumber: '',
            AccountName: '',
            BankName: '',
            IFSCCode: '',
            BranchName: '',
            BranchCode: '',
            PANNo: '',
            MICRNumber: '',
            TANNo: '',
            MobileNo: '',
            Email: '',
            IsActive: false,
            DataCollection: [],
        }));
        setPolicyValue(new SupplierPolicyDataCollection());
        setSupplierPolicy([]);
        setActiveId(false);
    }

    return (
        <div className="container-fluid form_border my-5">
            <form action="" >
                <div className="mb-1 mt-4 col-lg-10">
                    <div className='row'>
                        <div className="col-lg-6 col-sm-6 pb-2">
                            <div className="row">
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className='col-form-label required'>Name of Company</label>
                                </div>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input
                                        className='form-control'
                                        type="text"
                                        value={SupplierName || ""}
                                        disabled
                                        placeholder='Company Name'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-sm-6 pb-2"></div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Account Number</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='AccountNumber'
                                        name="AccountNumber"
                                        value={formValue?.AccountNumber}
                                        onChange={(e) => handleOnChange(e.target.name, onlyNumeric(e.target.value))}
                                        disabled={disabled ? true : false}
                                        placeholder='Account Number'
                                        maxLength={18}
                                    />
                                    {formError?.AccountNumber && <div className='text-danger fs_14'>{formError?.AccountNumber}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Account Name</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='AccountName'
                                        name="AccountName"
                                        value={formValue.AccountName}
                                        onChange={(e) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                        disabled={disabled ? true : false}
                                        placeholder='Account Name'
                                        maxLength={250}
                                    />
                                    {formError?.AccountName && <div className='text-danger fs_14'>{formError?.AccountName}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Bank Name</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='BankName'
                                        name="BankName"
                                        value={formValue.BankName}
                                        onChange={(e) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                        disabled={disabled ? true : false}
                                        placeholder='Bank Name'
                                        maxLength={250}
                                    />
                                    {formError?.BankName && <div className='text-danger fs_14'>{formError?.BankName}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">IFSC Code</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='IFSCCode'
                                        name="IFSCCode"
                                        value={formValue.IFSCCode}
                                        onChange={(e) => handleOnChange(e.target.name, (e.target.value).toUpperCase())}
                                        disabled={disabled ? true : false}
                                        placeholder='IFSC Code'
                                        // onBlur={handleIFSCBulr}
                                        maxLength={11}
                                    />
                                    {formError?.IFSCCode && <div className='text-danger fs_14'>{formError?.IFSCCode}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Branch Name</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='BranchName'
                                        name="BranchName"
                                        value={formValue.BranchName}
                                        onChange={(e) => handleOnChange(e.target.name, onlyAlphabets(e.target.value))}
                                        disabled={disabled ? true : false}
                                        placeholder='Branch Name'
                                        maxLength={250}
                                    />
                                    {formError?.BranchName && <div className='text-danger fs_14'>{formError?.BranchName}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Branch Code</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        name="BranchCode"
                                        value={formValue.BranchCode}
                                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                                        placeholder='Branch Code'
                                        maxLength={6}
                                        disabled
                                    />
                                    {formError?.BranchCode && <div className='text-danger fs_14'>{formError?.BranchCode}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">PAN Number</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='PANNumber'
                                        name="PANNo"
                                        value={formValue.PANNo}
                                        onChange={(e) => handleOnChange(e.target.name, (e.target.value).toUpperCase())}
                                        disabled={disabled ? true : false}
                                        placeholder='PAN Number'
                                        maxLength={10}
                                    />
                                    {formError?.PANNumber && <div className='text-danger fs_14'>{formError?.PANNumber}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">MICR Number</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='MICRNumber'
                                        name="MICRNumber"
                                        value={formValue.MICRNumber}
                                        onChange={(e) => handleOnChange(e.target.name, onlyNumeric(e.target.value))}
                                        disabled={disabled ? true : false}
                                        placeholder='MICR Number'
                                        maxLength={9}
                                    />
                                    {formError?.MICRNumber && <div className='text-danger fs_14'>{formError?.MICRNumber}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">TAN Number</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='TANNumber'
                                        name="TANNo"
                                        value={formValue.TANNo}
                                        onChange={(e) => handleOnChange(e.target.name, (e.target.value).toUpperCase())}
                                        disabled={disabled ? true : false}
                                        placeholder='TAN Number'
                                        maxLength={10}
                                    />
                                    {formError?.TANNumber && <div className='text-danger fs_14'>{formError?.TANNumber}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">Mobile Number</label>
                                </div>

                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <div className="input-group">
                                        <span className="input-group-text" id="prefixMobile"> +91 </span>
                                        <input className="form-control"
                                            type="text"
                                            id='MobileNumber'
                                            name="MobileNo"
                                            value={formValue.MobileNo}
                                            onChange={(e) => handleOnChange(e.target.name, onlyNumeric(e.target.value))}
                                            disabled={disabled ? true : false}
                                            maxLength={10}
                                            placeholder='Mobile Number'
                                        />
                                    </div>
                                    {formError?.MobileNumber && <div className='text-danger fs_14'>{formError?.MobileNumber}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label required">Account Email</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <input className="form-control"
                                        type="text"
                                        id='AccountEmail'
                                        name="Email"
                                        value={formValue.Email}
                                        onChange={(e) => handleOnChange(e.target.name, e.target.value)}
                                        disabled={disabled ? true : false}
                                        placeholder='Account Email'
                                        maxLength={150}
                                    />
                                    {formError?.AccountEmail && <div className='text-danger fs_14'>{formError?.AccountEmail}</div>}
                                </div>

                            </div>
                        </div>
                        <div className='col-lg-6 col-sm-6 pb-2'>
                            <div className='row'>
                                <div className="col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <label className="col-form-label">Account Status</label>
                                </div>
                                <div className=" col-lg-6 col-md-12 col-sm-12 mb-lg-1">
                                    <Switch
                                        onChange={handleisActive}
                                        checked={activeId}
                                        disabled={disabled ? true : false}
                                        className="react-switch"
                                    />
                                    {formError?.SupplierName && <div className='text-danger fs_14'>{formError?.SupplierName}</div>}
                                </div>
                                <ConfirmationModal
                                    show={modalShow}
                                    onHide={() => setModalShow(false)}
                                    noconfirm={() => handleConfirmation(false)}
                                    yesconfirm={() => handleConfirmation(true)}
                                />

                            </div>
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12 mt-4 mb-2'>
                            <div className="col-lg-12 col-md-12 col-sm-12">
                                <h5 className="">Supplier Payment Policy</h5>
                            </div>
                        </div>
                        {formError?.SupplierPayment && <div className='text-danger text-center fs_14'>{formError?.SupplierPayment}</div>}
                    </div>
                </div>
                <div className='row mb-1'>
                    <div className="col-lg-10">
                        <div className='row'>
                            <div className="col-lg-3 col-md-2 col-sm-12 mb-lg-1 mb-md-1">
                                <label className="col-form-label required">D-Travel</label>
                            </div>
                            <div className=" col-lg-3 col-md-4 col-sm-12 mb-1">
                                <Select
                                    className="dropdown select_dropdown custom_class"
                                    inputId='dTravelId'
                                    id='DTravel'
                                    name='dTravelId'
                                    options={dropdownData?.DTravel}
                                    value={dropdownData?.DTravel?.filter((list: selectOption) => list?.value === PolicyValue.dTravelId)}
                                    onChange={(e: any) => handleSelectChange('dTravelId', e)}
                                    isDisabled={disabled ? true : false}
                                    isSearchable
                                />
                                {formError?.DTravel && <div className='text-danger fs_14'>{formError?.DTravel}</div>}
                            </div>
                            <div className="col-lg-3 col-md-2 col-sm-12 mb-lg-1 mb-md-1">
                                <label className="col-form-label required">% of Supplier Payment Value</label>
                            </div>
                            <div className=" col-lg-3 col-md-4 col-sm-12 mb-1">

                                <Select
                                    className="dropdown select_dropdown custom_class"
                                    inputId='sPaymentId'
                                    id='sPaymentValue'
                                    name='PaymentValueD'
                                    options={dropdownData?.SupplierPaymentValue}
                                    value={dropdownData?.SupplierPaymentValue?.filter((list: selectOption) => list?.value === PolicyValue.sPaymentId)}
                                    onChange={(e: any) => handleSelectChange('sPaymentId', e)}
                                    isDisabled={disabled ? true : false}
                                    isSearchable
                                />
                                {formError?.sPaymentValue && <div className='text-danger fs_14'>{formError?.sPaymentValue}</div>}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-2 col-md-12 col-sm-12">
                        <div className="col-lg-1 col-md-12 col-sm-12 justify-content-center d-lg-block d-md-flex d-sm-flex mb-lg-1">
                            <button type="button"
                                className="btn btn-primary mx-1"
                                onClick={handleAddSupplierPolicy}
                                disabled={disabled ? true : false}
                            >
                                Add
                            </button>
                        </div>
                    </div>
                </div>
                <div className='mb-1 col-lg-12 col-md-12 mt-3'>
                    <table id="data" className="table table-hover" >
                        <thead>
                            <tr>
                                <th>D-Travel</th>
                                <th className='text-center'>Supplier Payment Value</th>
                                <th className='text-end pe-4'>Remove</th>
                            </tr>
                        </thead>
                        <tbody>
                            {SupplierPolicy && SupplierPolicy?.map((element, index) => {
                                return (
                                    <tr className="ReactTable" key={index}>
                                        <td >{element.dTravelValue}</td>
                                        <td className='text-center'>{element.sPaymentValue}</td>
                                        <td className='text-end'><button type="button"
                                            onClick={(e) => { handleRemoveSupplierPolicy(e, element.SeqNo) }}
                                            className="btn btn-primary mx-1" disabled={disabled ? true : false} >Remove</button></td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <div className="d-flex justify-content-center mt-4">
                    <button type="button" className="btn btn-primary mx-1" onClick={handleSaveUpdate}
                    // disabled={editDisabled || SupplierId <= 0}
                    > {addbuttontext} </button>
                    <button type="button" className="btn btn-primary mx-1" onClick={handleClear} disabled={disabled || cleardisable}>Clear</button>
                </div>

            </form>
        </div>
    )
}

export default AccountDetails
